module.exports = __webpack_public_path__ + "img/9791164791200.6b951477.jpg";